export const dndConstants = {
  SRC_FILE: 'SRC_FILE',
  SRC_PAGE: 'SRC_PAGE',
  COMMON: 'COMMON',
  SPLIT: 'SPLIT',
  GLOBAL_COMMON: 'GLOBAL_COMMON',
  DEST_ATT: 'DEST_ATT', // TODO: consider changing name to DEST_FILE
  DEST_PAGE: 'DEST_PAGE',
};
